import React from 'react';
import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

import { SearchContentEmptyMockResults } from './EmptyMockResults';
import { SearchContentEmpty } from './SearchContentEmpty';

export const SearchContentEmptyPage = () => {
  const foamEmptyTalentPageFlag =
    useFeatureFlag(FEATURE_FLAGS.foamContentSearchEmptyState) === 'enabled';

  return (
    <>
      {foamEmptyTalentPageFlag ? (
        <SearchContentEmptyMockResults />
      ) : (
        <SearchContentEmpty />
      )}
    </>
  );
};
